module.exports = __webpack_public_path__ + "static/home_galeria_4-e6ab2c5a7e025ed950018402e30b4e90.jpg";